   <h2 mat-dialog-title>{{ data.title | translate }}</h2>

<mat-dialog-content class="mat-typography">
  <form class="form-wrapper" [formGroup]="firmaForm" autocomplete=off>
    <div class="eineLinie">
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaDialog.name' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.firmaDialog.name' | translate"
        formControlName="name"
      />
      <mat-error *ngIf="firmaForm.controls.name.invalid">{{ getErrorMessage('name') | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaDialog.email' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.firmaDialog.email' | translate"
        formControlName="email"
      />
      <mat-error *ngIf="firmaForm.controls.email.invalid">{{ getErrorMessage('email') | translate }}</mat-error>
    </mat-form-field>
    </div>
    <div class="eineLinie">

    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaDialog.plz' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.firmaDialog.plz' | translate"
        formControlName="plz"
        [evenNumbersOnlyMax]="9999"
      />
      <mat-error *ngIf="firmaForm.controls.plz.invalid">{{ getErrorMessage('plz') | translate }}</mat-error>
    </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaDialog.ort' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.mitarbeiterverwaltung.firmaDialog.ort' | translate"
          formControlName="ort"
        />
        <mat-error *ngIf="firmaForm.controls.ort.invalid">{{ getErrorMessage('ort') | translate }}</mat-error>
      </mat-form-field>
    </div>
    <div class="eineLinie">
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaDialog.adr1' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.firmaDialog.adr1' | translate"
        formControlName="str1"
      />
      <mat-error *ngIf="firmaForm.controls.str1.invalid">{{ getErrorMessage('str1') | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaDialog.adr2' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.firmaDialog.adr2' | translate"
        formControlName="str2"
      />
      <mat-error *ngIf="firmaForm.controls.str2.invalid">{{ getErrorMessage('str2') | translate }}</mat-error>
    </mat-form-field></div>
    <div class="eineLinie">
  <mat-form-field appearance="outline" color="accent">
    <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaDialog.tel' | translate }}</mat-label>
    <input
      matInput
      [placeholder]="'pages.mitarbeiterverwaltung.firmaDialog.tel' | translate"
      formControlName="telefon"
    />
    <mat-error *ngIf="firmaForm.controls.telefon.invalid">{{ getErrorMessage('telefon') | translate }}</mat-error>
  </mat-form-field>
<!--
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaDialog.arbsol' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.firmaDialog.arbsol' | translate"
        formControlName="arbsol"
        [decimalNumbersOnlyMax]=24
        [kommaStellen]=2
        onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false" autocomplete=off
      />
      <mat-error *ngIf="firmaForm.controls.arbsol.invalid">{{ getErrorMessage('arbsol') | translate }}</mat-error>
    </mat-form-field>
    </div>
    <div class="eineLinie">
    -->
  <mat-form-field appearance="outline" color="accent">
    <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaDialog.branche' | translate }}</mat-label>
    <mat-select formControlName="branche">
      <mat-option [value]="null">Keine</mat-option>
      <mat-option *ngFor="let branche of ($branchen | async)" [value]="branche.key">
        {{branche.key }}
      </mat-option>
    </mat-select>
  </mat-form-field>
    </div>


  </form>
<div class="randAbstand">
  <div class="eineLinien">
  <h2 mat-dialog-title>{{ 'pages.mitarbeiterverwaltung.firmaDialog.firmaZeiten' | translate }}</h2>
  <div class="add-button-container">

    <button matTooltip="Info Zeiten Hinzufügen" mat-mini-fab class="pluscolor add-button-container" (click)="addFirmaZeit()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  </div>
<app-firma-table [firmaZeiten]="$firmaZeiten | async"></app-firma-table>
</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    [tabIndex]="-1"
    id="abbruch"
    color="accent"
    (click)="handleCancelClick()"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
    [disabled]="firmaForm.invalid"
  >
    {{ data.submitButtonLabel | translate }}
  </button>
</mat-dialog-actions>
